import { HttpMethod } from '../../constants';
function replaceEnterpriseId(enterpriseId: string): string {
  return this.path.replace(':enterpriseId', enterpriseId);
}
function replaceEnterpriseAndWorksiteId(enterpriseId: string, worksiteId: string): string {
  return this.path.replace(':enterpriseId', enterpriseId).replace(':worksiteId', worksiteId);
}
export const worksiteEndpoints = {
  [HttpMethod.Get]: {
    EnterpriseWorksites: {
      path: '/enterprises/:enterpriseId/worksites',
      route: replaceEnterpriseId
    },
    PublicEnterpriseWorksites: {
      path: '/p/enterprises/:enterpriseId/worksites',
      route: replaceEnterpriseId
    },
    EnterpriseWorksitesFilters: {
      path: '/enterprises/:enterpriseId/worksites/filters',
      route: replaceEnterpriseId
    },
    Worksite: {
      path: '/enterprises/:enterpriseId/worksites/:worksiteId',
      route: replaceEnterpriseAndWorksiteId
    }
  },
  [HttpMethod.Post]: {
    EnterpriseWorksites: {
      path: '/enterprises/:enterpriseId/worksites',
      route: replaceEnterpriseId
    }
  },
  [HttpMethod.Put]: {
    Worksite: {
      path: '/enterprises/:enterpriseId/worksites/:worksiteId',
      route: replaceEnterpriseAndWorksiteId
    },
    BatchAssignAccounts: {
      path: '/enterprises/:enterpriseId/worksites/:worksiteId/accounts/batch',
      route: replaceEnterpriseAndWorksiteId
    }
  },
  [HttpMethod.Delete]: {
    Worksite: {
      path: '/enterprises/:enterpriseId/worksites/:worksiteId',
      route: replaceEnterpriseAndWorksiteId
    },
    BatchDelete: {
      path: '/enterprises/:enterpriseId/worksites/batch',
      route: replaceEnterpriseId
    }
  }
};